import { useEffect, useState } from "react";
import { Loader2, RefreshCw, BarChart3 } from "lucide-react";
import { api } from "../../lib/api";

const fmt = (v) => (typeof v === "number" ? v.toLocaleString("es-MX", { maximumFractionDigits: 1 }) : v);

export default function ModuleComputed({ moduleKey }) {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get(`/mod/analytics/${moduleKey}`).then((r) => setCards(r.data.cards || [])).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(load, [moduleKey]); // eslint-disable-line

  return (
    <div className="space-y-3" data-testid="module-computed">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 overline text-navy/40"><BarChart3 className="w-3.5 h-3.5" /> Métricas en vivo (calculadas automáticamente)</div>
        <button onClick={load} className="btn btn-ghost text-sm" data-testid="computed-refresh"><RefreshCw className="w-3.5 h-3.5" /> Actualizar</button>
      </div>
      {loading ? <div className="py-8 flex justify-center text-navy/40"><Loader2 className="w-5 h-5 animate-spin" /></div> : (
        <div className="grid gap-4 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4">
          {cards.map((c, i) => (
            <div key={`${c.label}-${i}`} className="card-surface p-4" data-testid={`computed-card-${c.label}`}>
              <div className="text-xs text-navy/50 truncate">{c.label}</div>
              <div className="font-editorial text-3xl text-navy/90 mt-1">{fmt(c.value)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
